module.exports = __webpack_public_path__ + "img/3.598d3784.jpg";